import React, { useState, useEffect } from "react";
// import "../Styles/globals.css";
import { toAbsoluteUrl } from "../toAbsoluteUrl";
import { callApi } from "../API";
import { resendInvite, removeFromCompany } from "../allFunctions";
import Pagination from "../Components/pagination";
import { useNavigate } from "react-router-dom";
import InvitePage from "../Components/invitePage";
import BreadcrumbsComponent from "../Components/Breadcrumbs.jsx";



export default function Login() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState(0);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [remove, setRemove] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [firstLoadNoData, setFirstLoadNoData] = useState(false);
  const [breadCrump, setBreadCrump] = useState([{name:'Home' ,link:'/'},{name : 'My Team',link:'businessDashboard/myteam'}]);
  const handleClose = () => setOpen(false);
  
  
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const handleOpen = () => {
    setOpen(true);
  };
  function getStudents() {
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "filtringStudentsV2",
      page: page,
      search: search,
      limit: limit,
      lang: 1,
      apiType: activePage,
      bussinessUserId: '2974',
    }).then((data) => {
      console.log(data.usersInfo,data.usersInfo.length < 1);
      
      setLoading(1);
      setUsers(data.usersInfo);
      setData(data);
      if (firstLoad && data.usersInfo.length < 1) {
        setFirstLoadNoData(true);
      }
      setFirstLoad(false);
    }).catch((error)=>{
      console.log("error",error);
    });
  }
  useEffect(() => {
    getStudents();
  }, [activePage, page, limit, search,open,remove]);

  function switchPageView(params) {
    if (activePage != params) {
      setPage(1);
      setLoading(0);
      setActivePage(params);
      setLimit(10);
      setFirstLoad(true)
    }
  }
  function displayBody() {
    let studentsList = "";
    if ( users.length > 0) {
      studentsList = users.map((rowData, index) => {
        if (activePage == 0) {
          return (
            <tr key={index}>
              <td className="col-lg-2 col-6 order-1">
                <span className="d-block d-lg-none">ID Number</span>
                {rowData.emiratesID?rowData.emiratesID:"-"}
              </td>
              <td className="col-lg-2 col-6 order-2">
                <span className="d-block d-lg-none">Employee Name</span>{" "}
                {rowData.fullName ? rowData.fullName: rowData.fname && rowData.lname ?rowData.fname +" "+ rowData.lname  :'-'}
              </td>
              <td className="col-lg-5 col-6 order-3">
                <span className="d-block d-lg-none">Work Email</span>
                {rowData.userEmail ? rowData.userEmail :'-'}
              </td>
              <td className="col-lg-2 col-6 order-4">
                <span className="d-block d-lg-none">Work Email</span>{" "}
                <p
                  className={`${
                    rowData.statusOfInvitation == 2
                      ? "disabled-status"
                      : "active-status"
                  } `}
                >
                  {rowData.statusOfInvitation == 2 ? "Disabled" : "Active"}
                </p>
              </td>
              <td className="col-lg-1 col-12  align-text-media order-0">
                <div className="dropdown">
                  <img
                    // className="dropdown-toggle"
                    type="button"
                    id={`dropdownMenu${index}`}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    src={toAbsoluteUrl("/media/images/action-icon.svg")}
                    alt="action-icon"
                    className="notDark"
                  />
                  <img
                    // className="dropdown-toggle"
                    type="button"
                    id={`dropdownMenu${index}`}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    src={toAbsoluteUrl("/media/images/action-icon-dark.svg")}
                    className="darkMode"
                    alt="action-icon"
                  />
                  <div
                    className="dropdown-menu action-table-menu"
                    aria-labelledby={`dropdownMenu${index}`}
                  >
                    <button onClick={handleOpen} className="dropdown-item" type="button">
                      <img className="notDark" src={toAbsoluteUrl("/media/images/user-plus.svg")} />
                      <img className="darkMode" src={toAbsoluteUrl("/media/images/user-plus-dark.svg")} />
                      <span>Invite</span>
                    </button>
                    <button
                      onClick={() => {
                        removeFromCompany(rowData.userId ,rowData.statusOfInvitation);
                        remove ? setRemove(false):setRemove(true)
                      }}
                      className="dropdown-item"
                      type="button"
                    >
                      <img
                      className="notDark"
                        src={toAbsoluteUrl("/media/images/user-minus.svg")}
                      />
                      <img
                      className="darkMode"
                        src={toAbsoluteUrl("/media/images/user-minus-dark.svg")}
                      />
                      <span>Remove</span>
                    </button>
                    <button
                      onClick={() =>
                        navigate(`/businessDashboard/EmployeeDetails/${rowData.userId}`, {
                          state: {
                            pages: breadCrump,
                          },
                        })
                      }
                      className="dropdown-item "
                      type="button"
                    >
                      <img className="notDark" src={toAbsoluteUrl("/media/images/eye.svg")} />
                      <img className="darkMode" src={toAbsoluteUrl("/media/images/eye-dark.svg")} />
                      <span>View Details</span>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          );
        } else {
          return (
            <tr key={index}>
              <td className="col-lg-3 col-6 order-1">
                <span className="d-block d-lg-none">Work Email </span>{" "}
                {rowData.userEmail}
              </td>
              <td className="col-lg-3 col-6 order-2">
                <span className="d-block d-lg-none">Registration Date</span>{" "}
                {rowData.registartionDate == ""
                  ? "-"
                  : rowData.registartionDate}
              </td>
              <td className="col-lg-3 col-6 order-3">
                <span className="d-block d-lg-none">Invitations Date</span>{" "}
                {rowData.invitationDate}
              </td>
              <td className="col-lg-2 col-6 order-4">
                <span className="d-block d-lg-none">Status</span>
                <p
                  className={`${
                    rowData.statusOfInvitation == 0
                      ? "not-registered-status "
                      : "registered-status"
                  } `}
                >
                  {rowData.statusOfInvitation == 0
                    ? "Not Registered"
                    : "Registered"}
                </p>
              </td>
              <td className="col-lg-1 col-12  align-text-media order-0">
                <div className="dropdown">
                <img
                    // className="dropdown-toggle"
                    type="button"
                    id={`dropdownMenu${index}`}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    src={toAbsoluteUrl("/media/images/action-icon.svg")}
                    alt="action-icon"
                    className="notDark"
                  />
                  <img
                    // className="dropdown-toggle"
                    type="button"
                    id={`dropdownMenu${index}`}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    src={toAbsoluteUrl("/media/images/action-icon-dark.svg")}
                    className="darkMode"
                    alt="action-icon"
                  />
                  <div
                    className="dropdown-menu action-table-menu"
                    aria-labelledby={`dropdownMenu${index}`}
                  >
                    <button
                      onClick={() => {
                        if (rowData.statusOfInvitation == 0) {
                          resendInvite(rowData.userEmail);
                        } else {
                          handleOpen();
                        }
                      }}
                      className="dropdown-item"
                      type="button"
                    >
                      <img className="notDark" src={toAbsoluteUrl("/media/images/user-plus.svg")} />
                      <img className="darkMode" src={toAbsoluteUrl("/media/images/user-plus-dark.svg")} />
                      <span>
                        {rowData.statusOfInvitation == 0
                          ? "Resend Invite"
                          : "Invite"}
                      </span>
                    </button>
                    <button
                      onClick={() => {
                        let id = "";
                        if (rowData.statusOfInvitation == 0) {
                          id = rowData.id;
                        } else {
                          id = rowData.userId;
                        }
                        removeFromCompany(id, rowData.statusOfInvitation);
                        remove ? setRemove(false):setRemove(true)
                      }}
                      className="dropdown-item"
                      type="button"
                    >
                       <img
                      className="notDark"
                        src={toAbsoluteUrl("/media/images/user-minus.svg")}
                      />
                      <img
                      className="darkMode"
                        src={toAbsoluteUrl("/media/images/user-minus-dark.svg")}
                      />
                      <span>Remove</span>
                    </button>
                    <button
                      onClick={() =>
                        navigate(`/businessDashboard/EmployeeDetails/${rowData.userId}`, {
                          state: {
                            pages: breadCrump,
                          },
                        })
                      }
                      className={`dropdown-item ${
                        rowData.statusOfInvitation == 0 ? "disabled" : ""
                      } `}
                      type="button"
                    >
                      <img className="notDark" src={toAbsoluteUrl("/media/images/eye.svg")} />
                      <img className="darkMode" src={toAbsoluteUrl("/media/images/eye-dark.svg")} />
                      <span>View Details</span>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          );
        }
      });
    }else{
      studentsList = <tr >
              <td className="">
              No results found!
              </td>
              </tr>
    }
    return studentsList;
  }
  function displayHead(params) {
    if (activePage == 0) {
      return (
        <tr className="d-none d-lg-table-row">
          <th className="col-2">
            ID Number{" "}
          </th>
          <th className="col-2">
            Employee Name{" "}
          </th>
          <th className="col-5">
            Work Email{" "}
          </th>
          <th className="col-2">
            Status{" "}
          </th>
          <th className="col-1">Actions</th>
        </tr>
      );
    } else {
      return (
        <tr className="d-none d-lg-table-row">
          <th className="col-3">
            Work Email{" "}
          </th>
          <th className="col-3">
            Registration Date{" "}
          </th>
          <th className="col-3">
            Invitations Date{" "}
          </th>
          <th className="col-2">
            Status{" "}
          </th>
          <th className="col-1">Actions</th>
        </tr>
      );
    }
    // return headOfTable;
  }
  

  return (
    <div className="container">
      <div>
        <BreadcrumbsComponent pages={breadCrump} />
        <div className="header-of-page display-flex-with-space-between">
          <h1>My Team</h1>
          <a
            onClick={() => handleOpen()}
            className="rounded-btn gap-12 invite-btn display-flex-with-center font-weight-600 gap-12"
          >
            <img
              src={toAbsoluteUrl("/media/images/plus-with-background.svg")}
              alt="close"
            />
            Invite employees
          </a>
        </div>
        <div className="divider d-md-none d-block mt-4" />
        <div className="nav-items mt-5">
          <p
            className={`item-of-nav ${activePage == 0 ? "active" : ""}`}
            onClick={() => switchPageView(0)}
          >
            Employees List
          </p>
          <p
            className={`item-of-nav ${activePage == 1 ? "active" : ""}`}
            onClick={() => switchPageView(1)}
          >
            Invited Employees
          </p>
        </div>
        {/* <div> */}
        {!((users.length < 1) && firstLoadNoData) &&
          <div class="search-and-sort-table mt-4">
            <div className="search-table">
            <input
              type="text"
              class="search-input"
              placeholder="Search.."
              //   onkeyup={setActivePage()}
              onChange={(event) => {
                setSearch(event.target.value);
              }}
              autocomplete="new-password"
            />
            <img
              src={toAbsoluteUrl("/media/images/search.svg")}
              alt="search-icon"
            />
            </div>
          </div>
          
        }
        {/* </div> */}
        {loading == 0 ? (
          <div className="display-flex-with-center justify-content-center mt-5">
            <div class="spinner-border" role="status">
              <span class="sr-only"></span>
            </div>
          </div>
        ) : (
          <>
          {console.log('users.length ',users.length < 1 , firstLoadNoData)}
          {users.length < 1 && firstLoadNoData  ?
          <div className="no-data-message mt-5">
            <p>No members yet! Invite some to get started.</p>
          </div>
          :<>
            <table id="table" class="dashboard-table mt-4">
              <thead>{displayHead()}</thead>
              <tbody>{displayBody()}</tbody>
            </table>
            <Pagination
              limit={limit}
              setLimit={setLimit}
              setPage={setPage}
              
              {...data}
            />
           
          </>
          }
          </>
        )}
         {open && <InvitePage closeModal={handleClose} open={open} />}
      </div>
    </div>
  );
}
